/**
 * Authoritative snapshot_id → report name mapping (from backend):
 *
 *  17  Call In Queue          38  All Live
 *  25  Call Center Perf       45  Agent Team Perf
 *  13  Agent Call Perf        26  Agent Campaign Perf
 *  10  Agent Perf Report       8  Agent Call Summary
 *  21  Campaign Summary       23  Campaign Call Analysis
 *  32  DID Usage              50  Campaign Performance   (campaign_ids[])
 *  52  Daily Campaigns        51  Hourly Campaign Stats
 *  60  Call Reports CDR           (requires sub_type)
 * 100  Campaign File Load State
 * 101  Lead Recycle Details
 * 103  Dial vs Pending Detail
 *
 * Returns the "Dialer Reports" top-level item in the sidebarnavItem shape used
 * by the existing global sidebar template (3 levels max).
 * CDR sub-types are flattened to L3 with queryParams.
 */
export function getReportsMenuItem(): any {
  return {
    path: 'dialer-reports',
    title: 'Dialer Reports',
    icon: 'fas fa-chart-bar',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [

      // ── Live Reports ──────────────────────────────────────────────────────
      {
        path: '',
        title: 'Live Reports',
        icon: 'fas fa-broadcast-tower text-white',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [
          item('dialer-reports/17', 'Call in Queue', 'fas fa-phone-volume text-white'),
          item('dialer-reports/38', 'All Live',      'fas fa-circle text-white'),
        ]
      },

      // ── Performance Reports ───────────────────────────────────────────────
      {
        path: '',
        title: 'Performance Reports',
        icon: 'fas fa-chart-line text-white',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [
          item('dialer-reports/25', 'Call Center Performance',   'fas fa-headphones text-white'),
          item('dialer-reports/45', 'Agent Team Performance',    'fas fa-people-arrows text-white'),
          item('dialer-reports/13', 'Agent Call Performance',    'fas fa-phone text-white'),
          item('dialer-reports/26', 'Agent Campaign Performance','fas fa-bullhorn text-white'),
          item('dialer-reports/10', 'Agent Performance Report',  'fas fa-user-check text-white'),
          item('dialer-reports/8',  'Agent Call Summary',        'fas fa-clipboard-list text-white'),
        ]
      },

      // ── Campaign Reports ──────────────────────────────────────────────────
      {
        path: '',
        title: 'Campaign Reports',
        icon: 'fas fa-bullhorn text-white',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [
          item('dialer-reports/21', 'Campaign Summary',            'fas fa-file-alt text-white'),
          item('dialer-reports/23', 'Campaign Call Analysis',      'fas fa-chart-bar text-white'),
          item('dialer-reports/32', 'DID Usage Report',            'fas fa-book text-white'),
          item('dialer-reports/50', 'Campaign Performance',        'fas fa-tachometer-alt text-white'),
          item('dialer-reports/52', 'Daily Campaigns Report',      'fas fa-calendar-day text-white'),
          item('dialer-reports/51', 'Hourly Campaign Stats',       'fas fa-clock text-white'),
        ]
      },

      // ── CDR Reports ───────────────────────────────────────────────────────
      // snapshot_id=60 flattened to L3; each leaf carries its sub_type queryParam
      {
        path: '',
        title: 'CDR Reports',
        icon: 'fas fa-phone-alt text-white',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [
          itemQ('dialer-reports/60', 'Calls Detail',    'fas fa-list text-white',             { sub_type: 'calls' }),
          itemQ('dialer-reports/60', 'Daily Rollup',    'fas fa-calendar-alt text-white',     { sub_type: 'daily' }),
          itemQ('dialer-reports/60', 'A-Leg Hourly',    'fas fa-hourglass-half text-white',   { sub_type: 'aleg_hourly' }),
          itemQ('dialer-reports/60', 'Transfer Hourly', 'fas fa-exchange-alt text-white',     { sub_type: 'xfer_hourly' }),
        ]
      },

      // ── Lead Reports ──────────────────────────────────────────────────────
      {
        path: '',
        title: 'Lead Reports',
        icon: 'fas fa-user-plus text-white',
        class: 'has-arrow',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [
          item('dialer-reports/100', 'Campaign File Load State',        'fas fa-file-upload text-white'),
          item('dialer-reports/101', 'Lead Recycle Details',            'fas fa-recycle text-white'),
          item('dialer-reports/103', 'Campaign Dial vs Pending Detail', 'fas fa-align-left text-white'),
        ]
      },

    ]
  };
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

function item(path: string, title: string, icon: string): any {
  return { path, title, icon, class: '', label: '', labelClass: '', extralink: false, submenu: [] };
}

function itemQ(
  path: string,
  title: string,
  icon: string,
  queryParams: { [k: string]: string }
): any {
  return { path, title, icon, class: '', label: '', labelClass: '', extralink: false, submenu: [], queryParams };
}
